import { ReactNode } from 'react';
import Spinner from '../Spinner';
import styles from './style.module.scss';

type ButtonType =
    | 'Primary'
    | 'Secondary'
    | 'Error'
    | 'Light'
    | 'Link'
    | 'Outline-Primary'
    | 'Solid-Blue'
    | 'Outline-Dark';

interface Props {
    text: string;
    onClick?: any;
    icon?: ReactNode;
    type?: ButtonType;
    loading?: boolean;
    disabled?: boolean;
    className?: string;
    iconPosition?: 'Left' | 'Right';
    htmlType?: "button" | "submit" | "reset" | undefined;
};

function Button(props: Props) {
    const {
        icon,
        type,
        text,
        onClick,
        loading,
        htmlType,
        disabled,
        className,
        iconPosition,
    } = props;

    return (
        <button
            className={`${styles.button}${className ? ` ${className}` : ''}`}
            onClick={onClick}
            disabled={disabled || loading}
            data-button-type={type}
            type={htmlType}
        >
            {icon && !loading && iconPosition === 'Left' && icon}
            {loading ? <Spinner /> : text}
            {icon && !loading && iconPosition === 'Right' && icon}
        </button>
    );
};

export default Button;
